// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "footer {\n  color: var(--primary-fore-color);\n}\nfooter > div {\n  width: 100%;\n}\n.version {\n  position: absolute;\n  right: 0px;\n  bottom: -12px;\n}", ""]);
// Exports
module.exports = exports;
